import React, { lazy, Suspense } from "react";
import ReactDom from "react-dom";
import { Image, Modal } from "react-bootstrap";
// import ReactPlayer from "react-player";
const ReactPlayer = lazy(() => import("react-player"));

export default function VideoPlayerModal({
  showVideoModal,
  url,
  onClose,
  videoTitle
}) {
  return ReactDom.createPortal(
    <>
      <Modal
        show={showVideoModal}
        onHide={onClose}
        className="videoPlayerModal"
      >
        <Modal.Header closeButton>
          <Modal.Title className="pt-3 pl-3">{videoTitle}</Modal.Title>
        </Modal.Header>
        <Suspense fallback={<div>Loading video player...</div>}>
          <ReactPlayer wrapper="div" pip={false} controls="true" url={url} />
        </Suspense>
      </Modal>
    </>,
    document.getElementById("video-player-modal")
  );
}

export { VideoPlayerModal };
